import { dateRangeFilters } from './dateRangeFilters'
import { FilterOptions, FilterCategory } from './types'
import { useChannelFilters } from './useChannelFilters'
import { useLabelFilters } from './useLabelFilters'
import { useStoryFilters } from './useStoryFilters'
import { workflowStatusFilters } from './workflowStatusFilters'

type UseFilterData = (
  workspaceId: number,
  disabledCategories?: Array<FilterCategory>
) => {
  loading: boolean
  filterOptions: FilterOptions
}

export const useFilterData: UseFilterData = (
  workspaceId,
  disabledCategories
) => {
  const categoryEnabled = (category: FilterCategory) =>
    disabledCategories === undefined || !disabledCategories?.includes(category)

  const storyResult = useStoryFilters({
    enabled: categoryEnabled(FilterCategory.story),
    workspaceId,
  })
  const labelSetResult = useLabelFilters({
    enabled: categoryEnabled(FilterCategory.labelSet),
    workspaceId,
  })
  const channelResult = useChannelFilters({
    enabled: categoryEnabled(FilterCategory.channel),
    workspaceId,
  })

  const filterOptions: FilterOptions = []

  if (
    categoryEnabled(FilterCategory.story) &&
    storyResult.isSuccess &&
    storyResult.data !== null
  ) {
    filterOptions.push(storyResult.data)
  }

  if (
    categoryEnabled(FilterCategory.labelSet) &&
    labelSetResult.isSuccess &&
    labelSetResult.data !== null
  ) {
    filterOptions.push(labelSetResult.data)
  }

  if (
    categoryEnabled(FilterCategory.channel) &&
    channelResult.isSuccess &&
    channelResult.data !== null
  ) {
    filterOptions.push(channelResult.data)
  }

  if (categoryEnabled(FilterCategory.workflowStatus)) {
    filterOptions.push(workflowStatusFilters)
  }

  if (categoryEnabled(FilterCategory.date)) {
    filterOptions.push(dateRangeFilters)
  }

  const loading =
    storyResult.isInitialLoading ||
    labelSetResult.isInitialLoading ||
    channelResult.isInitialLoading

  return {
    loading,
    filterOptions,
  }
}
